(() => {
  const TIERS = [
    { items: 4, code: 'PROMO20' },
    { items: 3, code: 'PROMO15' },
    { items: 2, code: 'PROMO10' },
  ];
  const TIER_CODES = TIERS.map((tier) => tier.code);

  function getTargetCode(itemCount) {
    const tier = TIERS.find((entry) => itemCount >= entry.items);
    return tier ? tier.code : null;
  }

  function getAppliedCodes(cart) {
    const codes = new Set();

    cart?.discount_codes?.forEach((entry) => {
      if (entry.code) codes.add(entry.code.toUpperCase());
    });

    document.querySelectorAll('[data-minimog-cart-discounts] .m-cart__discount--item').forEach((node) => {
      const code = node.dataset.discountCode;
      if (code) codes.add(code.toUpperCase());
    });

    return codes;
  }

  function syncDiscount(cart) {
    if (!window.MinimogSettings?.routes?.cart_update_url || !cart) return;
    if (document.body.dataset.tfRewardSyncing === 'true') return;

    const itemCount = cart.item_count || 0;
    const targetCode = getTargetCode(itemCount);
    const applied = getAppliedCodes(cart);
    const appliedTierCodes = [...applied].filter((code) => TIER_CODES.includes(code));
    const nonTierCodes = [...applied].filter((code) => !TIER_CODES.includes(code));

    const tierMatches =
      appliedTierCodes.length === (targetCode ? 1 : 0) &&
      (!targetCode || appliedTierCodes[0] === targetCode);

    if (tierMatches) return;

    const discounts = nonTierCodes.slice();
    if (targetCode) discounts.push(targetCode);

    document.body.dataset.tfRewardSyncing = 'true';

    const formData = new FormData();
    formData.append('discount', discounts.join(','));

    fetch(MinimogSettings.routes.cart_update_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        const cartJson = await (await fetch(`${MinimogSettings.routes.cart}.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })).json();

        if (parsedState.sections) cartJson.sections = parsedState.sections;

        if (window.MinimogEvents && window.MinimogTheme) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: cartJson });
        }
      })
      .catch((error) => {
        console.error('Trango reward discount sync failed:', error);
      })
      .finally(() => {
        delete document.body.dataset.tfRewardSyncing;
      });
  }

  function init() {
    if (!window.MinimogEvents || !window.MinimogTheme) return;

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, ({ cart }) => {
      syncDiscount(cart);
    });

    if (window.MinimogSettings?.routes?.cart) {
      fetch(`${MinimogSettings.routes.cart}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => response.json())
        .then((cart) => syncDiscount(cart))
        .catch(() => {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
